import React, { useEffect, useState } from "react";
import { Card, CardContent, Box, Tabs, Tab, Fade } from "@mui/material";
import { useTheme } from "@mui/material/styles";
import {
  Timeline,
  TrendingUp,
  BarChart,
  Notifications,
} from "@mui/icons-material";

// Import tab components
import OverviewTab from "./tabs/OverviewTab.jsx";
import PricesTab from "./tabs/PricesTab.jsx";
import VolumeTab from "./tabs/VolumeTab.jsx";
import TrendsTab from "./tabs/TrendsTab.jsx";
import NewsTab from "./tabs/NewsTab.jsx";

const MarketTabs = ({
  country,
  currentCountryData,
  // countryVolumeData,
  searchTerm,
  setSearchTerm,
  // filteredData,
  sortBy,
  handleSort,
  getChangeColor,
  getChangeIcon,
  // currencySymbols,
  isLoggedIn,
}) => {
  const [tabValue, setTabValue] = useState(0);
  const theme = useTheme();

  const [page, setPage] = useState(1);
  const entriesPerPage = 20;

  useEffect(() => {
    setPage(1); // reset page when tab changes
  }, [tabValue]);

  return (
    <Fade in timeout={1500}>
      <Box>
        {/* Disclaimer Note */}
        <Box
          sx={{
            mb: 2,
            px: 2,
            py: 2,
            borderRadius: 2,
            backgroundColor: "rgba(244,197,66,0.3)", // soft yellow
            color: "#856404", // dark yellow text
            fontSize: "0.875rem",
            fontWeight: 500,
            textAlign:"center"
          }}
        >
          Disclaimer: “Prices are sourced from LME and shown in your selected
          currency for reference only. Taxes, premiums, and actual transaction
          rates are not included.”
        </Box>

        <Card
          sx={{
            borderRadius: 4,
            boxShadow: theme.shadows[12],
            background: "background.paper",
            overflow: "hidden",
          }}
        >
          <CardContent sx={{ p: 0 }}>
            {/* Tabs */}
            <Box sx={{ borderBottom: 1, borderColor: "divider", px: 3, pt: 3 }}>
              <Tabs
                value={tabValue}
                onChange={(e, newValue) => setTabValue(newValue)}
                sx={{
                  "& .MuiTab-root": {
                    fontWeight: "medium",
                    fontSize: "1rem",
                    textTransform: "none",
                    minWidth: "auto",
                    px: 3,
                  },
                }}
              >
                <Tab
                  label="Overview"
                  icon={<Timeline />}
                  iconPosition="start"
                />
                <Tab
                  label="Prices"
                  icon={<TrendingUp />}
                  iconPosition="start"
                />
                <Tab label="Volume" icon={<BarChart />} iconPosition="start" />
                <Tab label="Trends" icon={<Timeline />} iconPosition="start" />
                <Tab
                  label="News"
                  icon={<Notifications />}
                  iconPosition="start"
                />
              </Tabs>
            </Box>

            <Box sx={{ p: 3 }}>
              {/* Overview Tab */}
              {tabValue === 0 && (
                <OverviewTab
                  searchTerm={searchTerm}
                  setSearchTerm={setSearchTerm}
                  currentCountryData={currentCountryData}
                  // filteredData={filteredData}
                  sortBy={sortBy}
                  handleSort={handleSort}
                  getChangeColor={getChangeColor}
                  getChangeIcon={getChangeIcon}
                  // currencySymbols={currencySymbols}
                  country={country}
                  page={page}
                  setPage={setPage}
                  entriesPerPage={entriesPerPage}
                  isLoggedIn={isLoggedIn}
                />
              )}

              {/* Prices Tab */}
              {tabValue === 1 && (
                <PricesTab
                  country={country}
                  currentCountryData={currentCountryData}
                  getChangeColor={getChangeColor}
                  getChangeIcon={getChangeIcon}
                  // currencySymbols={currencySymbols}
                  isLoggedIn={isLoggedIn}
                />
              )}

              {/* Volume Tab */}
              {tabValue === 2 && (
                <VolumeTab
                  country={country}
                  currentCountryData={currentCountryData}
                  isLoggedIn={isLoggedIn}
                  // countryVolumeData={countryVolumeData}
                />
              )}

              {/* Trends Tab */}
              {tabValue === 3 && (
                <TrendsTab
                  country={country}
                  currentCountryData={currentCountryData}
                  isLoggedIn={isLoggedIn}
                />
              )}

              {/* News Tab */}
              {tabValue === 4 && (
                <NewsTab
                  country={country}
                  currentCountryData={currentCountryData}
                  page={page}
                  setPage={setPage}
                  entriesPerPage={entriesPerPage}
                />
              )}
            </Box>
          </CardContent>
        </Card>
      </Box>
    </Fade>
  );
};

export default MarketTabs;
